var play_icon_rtlignore_default = {
  "shadow": "yd1TD",
  "playIcon": "_7n0uP"
};
export {
  play_icon_rtlignore_default as default
};
//# sourceMappingURL=play-icon.rtlignore-scss.js.map
